import ActivityCard from "../../../../../CommonComponents/ActivityCard";
import { SOAActivitySkeleton } from "./SOAActivitySkeleton";


const SOAActivity = (Props) => {
  // console.log("Your Activity Data",Props.data);

  if(!Props?.data?.length>0){
    return(
      <SOAActivitySkeleton/>
    );
  }

  return (
    <div className="SOAActivity">
        <>
          <div className="SOAActivity_title">Your Activity</div>
          <div className="SOAActivity_content">
            {Props.data?.length > 0 &&
              Props.data.map((data) => <ActivityCard data={data} key={data.libtype}/>)}
          </div>
        </>
    </div>
  );
};

export default SOAActivity;